import React from 'react'
import { Router, Route, browserHistory, IndexRoute, IndexRedirect } from 'react-router'
import '../../../node_modules/semantic-ui-css/semantic.min.css' // css webpack import

import Shell from '../shell'
import AuthPage from '../../pages/auth'
import SignUpPage from '../../pages/signup'
import ResetPassword from '../../pages/resetpassword'
import ConfirmEmail from '../../pages/confirmemail'
import MemberInvitation from '../../pages/memberinvitation'
import AppShell from '../appshell'
import IssuesLayout from '../../pages/issues/layout'
import IssuesOverview from '../../pages/issues/overview'
import IssuesSettings from '../../pages/issues/settings'
import SettingsLayout from '../../pages/settings/layout'
import ProfileSettings from '../../pages/settings/profile'
import DevicesSettings from '../../pages/settings/devices'
import TemplateSettings from '../../pages/settings/templates'
import BillingSettings from '../../pages/settings/billing'
import TeamSettings from '../../pages/settings/team'
import TemplateCustomisation from '../../pages/settings/template-customisation/index'
import {connect} from 'react-redux'
import {getBasicData} from '../../actions/account.action'
import {getTemplatesAction} from '../../actions/template.action'
import featureConfig from '../../services/features/config'
import isFeatureAllowed from '../../services/features/feature-check'

const featureIds = featureConfig.featureIds

const NoMatch = () => {
  return <h1>Content not found</h1>
}

class Routing extends React.Component {

  redirectFunction () {
    const {token} = this.props
    if (token === null || token === undefined) {
      let pathname = browserHistory.getCurrentLocation().pathname
      if (pathname !== '/auth/resetpassword' && pathname !== '/auth/memberinvitation' && pathname !== '/auth/signup' && pathname !== '/auth/confirmemail') {
        const isDevMode = (window.location.search === '?dev=true')
        const isReset = (window.location.search === '?reset=true')
        let url = isDevMode ? '/auth?dev=true' : '/auth'
        url = isReset ? (isDevMode ? `${url}&reset=true` : `${url}?reset=true`) : url
        browserHistory.push(url)
      }
    } else {
      let pathname = browserHistory.getCurrentLocation().pathname
      const redirectPath = ['/auth', '/auth/resetpassword', '/auth/signup',
        '/auth/memberinvitation', '/', '/auth/confirmemail', '/issues/overview/']
      if (redirectPath.includes(pathname)) {
        if (this.props.templates[0]) {
          pathname = '/issues/overview/' + this.props.templates[0]._id
        } else {
          pathname = '/issues/overview/'
        }
      }
      browserHistory.push(pathname)
    }
  }
  componentWillUpdate (nextProps) {
    if (this.props.token !== nextProps.token) {
      this.props.getBasicData()
      this.props.getTemplatesAction()
    }
  }
  componentDidUpdate () {
    this.redirectFunction()
  }
  componentDidMount () {
    this.redirectFunction()
    this.props.getTemplatesAction()
  }
  render () {
    return (
      <Router history={browserHistory}>
        <Route path='auth' component={Shell}>
          <IndexRoute component={AuthPage} />
          <Route path='signup' component={SignUpPage} />
          <Route path='resetpassword' component={ResetPassword} />
          <Route path='memberinvitation' component={MemberInvitation} />
          <Route path='confirmemail' component={ConfirmEmail} />
          <Route path='*' component={NoMatch} />
        </Route>

        <Route component={AppShell}>

          {/* Incidents */}
          <Route path='issues' component={IssuesLayout}>
            <IndexRedirect to='overview' />
            <Route path='overview' component={IssuesOverview} />
            <Route path='overview/:templateId' component={IssuesOverview} />
            <Route path='settings' component={IssuesSettings} />
            <Route path='*' component={NoMatch} />
          </Route>

          {/* settings */}
          <Route path='settings' component={SettingsLayout}>
            <IndexRedirect to='profile' />
            <Route path='profile' component={ProfileSettings} />
            <Route path='billing' component={BillingSettings} />
            <Route path='devices' component={DevicesSettings} />
            <Route path='team' component={TeamSettings} />
            <Route path='templates' component={TemplateSettings} />
            <Route path='templates/:templateId' component={TemplateCustomisation} />
            <Route path='*' component={NoMatch} />
          </Route>

          <Route path='*' component={NoMatch} />
        </Route>
      </Router>
    )
  }
}

function mapStateToProps (state) {
  return {token: state.account.token, templates: state.templates.templates, location: state.account.user && state.account.user.locations_data[0]}
}

export default connect(mapStateToProps, {getBasicData, getTemplatesAction})(Routing)



// WEBPACK FOOTER //
// ./src/containers/routing/index.js